import EventEmitter = require("eventemitter3");

// import 'youtube';

class YTPlayer {

    private player: any;
    public isPlaying: boolean;
    public isLoop: number;
    public isMute: number;
    public isAutoPlay: number;
    public hasControl: number;
    public videoID: string;
    public selector: string;
    public emitter: EventEmitter;
    public static VideoEvent: any = {
        PLAYER_READY: "playerReady",
        ON_PLAYING: "onPlaying",
        ON_PAUSE: "onPause"
    };

    constructor(selector: string, videoId: string, loop: boolean = false, autoplay: boolean = false, controls: boolean = true, mute: boolean = false) {

        this.isPlaying = false;
        this.isLoop = (loop == true) ? 1 : 0;
        this.hasControl = (controls == true) ? 1 : 0;
        this.isAutoPlay = (autoplay == true) ? 1 : 0;
        this.isMute = (mute == true) ? 1 : 0;

        this.videoID = videoId;
        this.selector = selector;
        this.emitter = new EventEmitter();
        this.createPlayer();
    }

    private createPlayer(): void {

        this.player = new (<any>window).YT.Player(this.selector, {
            width: '1920',
            height: '1080',
            videoId: this.videoID,
            playerVars: {
                'autoplay': this.isAutoPlay,
                'loop': 0,
                'controls': this.hasControl,
                'rel': 0,
                'mute': this.isMute
            },
            events: {
                'onReady': this.onPlayerReady.bind(this),
                'onStateChange': this.onPlayerStateChange.bind(this)
            }
        });
    }

    private onPlayerReady(event: any) {
        this.emitter.emit(YTPlayer.VideoEvent.PLAYER_READY);
    }

    private onPlayerStateChange(event: any) {

        if (event.data == -1) {
            //unstarted
        }

        if (event.data == 0) {
            //ended
            this.isPlaying = false;
            if (this.isLoop == 1) {
                this.seekTo(0);
                this.play();
            }
        }

        if (event.data == 1) {
            //playing
            this.isPlaying = true;
            this.emitter.emit(YTPlayer.VideoEvent.ON_PLAYING);
        }

        if (event.data == 2) {
            //paused
            this.isPlaying = false;
            this.emitter.emit(YTPlayer.VideoEvent.ON_PAUSE);
        }

        if (event.data == 3) {
            //buffering
        }

        if (event.data == 5) {
            //video cued
        }
    }

    public play(): void {
        this.player.playVideo();
    }

    public pause(): void {
        this.player.pauseVideo();
    }

    public stop(): void {
        this.player.stopVideo();
    }

    public seekTo(time: number): void {
        this.player.seekTo(time);
    }

    public changeVideo(id: string): void {
        this.videoID = id;
        this.player.loadVideoById(id);
    }

}

export = YTPlayer;